// SaveBeforeVariantModal.jsx
import React from "react";
import { ExclamationTriangleIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function SaveBeforeVariantModal({
  isOpen,
  onClose,
  onSaveAndContinue,
  onDiscardAndSwitch,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-fadeIn">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl border border-gray-100">

        {/* Header */}
        <div className="flex items-start justify-between p-6 pb-4">
          <div className="flex items-center gap-3">
            <div className="bg-amber-100 p-2 rounded-xl">
              <ExclamationTriangleIcon className="h-6 w-6 text-amber-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                Unsaved Base Product
              </h3>
              <p className="text-sm text-gray-500">
                You have unsaved changes.
              </p>
            </div>
          </div>

          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 pb-6">
          <p className="text-gray-600 text-sm leading-relaxed mb-6">
            If you switch to create variants now, your generated base product
            SKU will be lost.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2.5 rounded-lg text-gray-600 hover:bg-gray-100 transition"
            >
              Cancel
            </button>

            <button
              onClick={onDiscardAndSwitch}
              className="px-4 py-2.5 rounded-lg border border-red-200 text-red-600 hover:bg-red-50 transition"
            >
              Discard 
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}